<template>
  <v-tooltip top>
    <v-btn
      fab
      dark
      small
      :loading="loading"
      color="amber darken-2"
      slot="activator"
      @click="loading ? '' : download()"
    >
      <v-icon>file_download</v-icon>
    </v-btn>
    <span>{{title}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    title: String,
    loading: Boolean
  },
  methods: {
    download() {
      this.$emit("download");
    }
  }
};
</script>

<style>
</style>
